module.exports = __webpack_public_path__ + "static/media/claim-saudi.7321a3af.svg";